import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlatnoscService } from '../../@core/http/platnosc.service';
import { Subscription } from 'rxjs';
import { Platnosc } from '../../shared/models/platnosc.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { NbToastrService } from '@nebular/theme';
import { PlatnosciTabelaComponent } from './tabela/platnosci-tabela.component';

@Component({
  selector: 'ngx-platnosci',
  templateUrl: './platnosci.component.html',
  styleUrls: ['./platnosci.component.scss'],
})
export class PlatnosciComponent implements OnInit, OnDestroy, AfterViewInit {

  platnosci: Platnosc[];
  zakresDat: ZakresDat;
  hideSummary = false;

  @ViewChild(PlatnosciTabelaComponent) tabelaComponent: PlatnosciTabelaComponent;

  private platnoscSubscription: Subscription;
  private queryParamsSubscription: Subscription;

  constructor(
    private readonly platnoscService: PlatnoscService,
    private toastrService: NbToastrService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.hideSummary = params.hideSummary === 'true';
    });
  }

  ngAfterViewInit() {
    if (this.hideSummary) {
      setTimeout(() => {
        this.setPreviousMonth();
      }, 100);
    }
  }

  private setPreviousMonth() {
    const today = new Date();
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    
    const zakresDat = new ZakresDat(previousMonth, lastDayOfPreviousMonth);
    this.onChangeZmianaZakresu(zakresDat);
  }

  ngOnDestroy(): void {
    if (this.platnoscSubscription) {
      this.platnoscSubscription.unsubscribe();
    }
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.platnoscSubscription = this.platnoscService
      .getPlatnosci(zakresDat)
      .subscribe(response => {
        this.platnosci = response;
      });
  }

  onChangeTab($event) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  get allInvoicesPaid(): boolean {
    return this.tabelaComponent?.sumaKwotPozostalych() === 0;
  }

  kopiujNumer() {
    navigator.clipboard.writeText('68175000120000000013837578');
    this.toastrService.show('', 'Skopiowano numer konta', { status: 'success' });
  }
}
